<template>
    <div class="login-container">
      <b-container class="d-flex flex-column justify-content-center align-items-center min-vh-100">
        <transition name="fade-move" appear>
          <b-card v-if="showCard" class="login-card" border-variant="light">
            <b-card-title class="text-center">Bienvenidos al sistema</b-card-title>
            <b-card-body>
              <b-form @submit.prevent="onSubmit">
                <b-form-group label="Correo Electrónico" label-for="email-input">
                  <b-form-input
                    id="email-input"
                    type="email"
                    v-model="user.email"
                    required
                    placeholder="Ingresa tu correo electrónico"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Contraseña" label-for="password-input">
                  <b-input-group>
                    <b-form-input
                      id="password-input"
                      :type="showPassword ? 'text' : 'password'"
                      @keydown.enter.prevent="login"
                      v-model="user.password"
                      required
                      placeholder="Ingresa tu contraseña"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button 
                        @click="showPassword = !showPassword" 
                        variant="outline-secondary"
                        v-b-tooltip.hover 
                        :title="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                      >
                        <span v-if="showPassword">👁️</span>
                        <span v-else>👁️‍🗨️</span>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-button
                  type="submit"
                  @click.prevent="login"
                  :disabled="!isFormValid"
                  variant="success"
                  block
                >
                  Iniciar Sesión
                </b-button>
              </b-form>
              <b-card-text v-if="error">
                <b-alert class="mt-4" show dismissible fade variant="danger">{{ error }}</b-alert>
              </b-card-text>
            </b-card-body>
          </b-card>
        </transition>
        <div class="logo-container">
          <b-img class="logo-image" :src="logoImage" fluid alt="B4B Logo"></b-img>
        </div>
      </b-container>
    </div>
</template>

<script>
import logoImage from '@/assets/image/B4B.png'
import { mapActions } from "vuex";
export default {
    data() {
        return {
            email: "",
            password: "",
            error: "",
            user: {
              email: '',
              password: '',
            },
            logoImage,
            showCard: false, // Nueva propiedad para controlar la visibilidad del card
            showPassword: false, // Nueva propiedad para controlar la visibilidad de la contraseña
        };
    },
    computed: {
        isFormValid() {
            return this.user.email !== '' && this.user.password !== '';
        },
    },
    created() {
        this.checkToken();
        document.title = "B4B";
    },
    mounted() {
        this.showCard = true; // Mostrar el card después de que el componente esté montado
    },
    methods: {
        ...mapActions('auth', {
            _signIn: 'signIn',
            _alreadyAuth: 'getUser',
        }),
        checkToken() {
            if (localStorage.getItem('user-token')) {
            this._alreadyAuth();
            }
        },
        async login() {
            this.error = "";
            await this._signIn(this.user)
            .then((success) => {
                if (success) {
                this.error = success;
                }
            })
            .catch((error) => {
                this.error = error;
            });
        },
    },
};
</script>
  
<style>
.login-container {
    background-image: url('~@/assets/image/login-background.jpg'); /* Ruta de tu imagen de fondo */
    background-size: cover; /* Asegura que la imagen cubra todo el contenedor */
    background-position: center; /* Centra la imagen */
    height: 100vh;
}
  
.login-card {
    background-color: #ffffff; /* Color de fondo para la tarjeta (blanco) */
    max-width: 600px; /* Ancho máximo de la tarjeta */
    width: 100%; /* Ancho completo */
    margin: 20px auto; /* Margen para centrar */
}
  
.logo-container {
    display: flex;
    justify-content: flex-end; /* Alinea la imagen a la derecha */
    width: 100%;
    margin-top: 20px; /* Ajusta este valor para colocar la imagen debajo del card */
}
  
.logo-image {
    width: 300px;
    height: 150px;
    margin-right: 240px;
}
  
.fade-move-enter-active, .fade-move-leave-active {
    transition: opacity 1s, transform 1s;
}
  
.fade-move-enter, .fade-move-leave-to {
    opacity: 0;
    transform: translateY(100px);
}
  
@media (max-width: 768px) {
    .login-card {
        max-width: 90%; /* Ajusta el tamaño en pantallas pequeñas */
    }
    .logo-image {
        width: 150px;
        height: 100px;
        margin-top: 10px;
        margin-right: 10px;
    }
}
@media (max-width: 1024px) {
    .logo-image {
        width: 200px;
        height: 150px;
        margin-top: 10px;
        margin-right: 40px;
    }
}
</style>
  